import { lazy } from 'react';
import { createRoot } from 'react-dom/client';
import useAsync from 'react-use/lib/useAsync';
import { loadConfig } from './app/config';
import './index.css';

if (process.env.NODE_ENV === 'production') {
  const versionText = [`buildDate: ${process.env.REACT_APP_BUILD_DATE}`, `sha: ${process.env.REACT_APP_BUILD_FULL_SHA}`].join(', ');
  console.log(`[ID TECH SSO] ${versionText}`);
}

const App = lazy(() => import('./app/App'));

function Root() {
  const loadingState = useAsync(async () => {
    await loadConfig();
  }, []);
  return !loadingState.loading && <App />;
}

createRoot(document.getElementById('root')).render(<Root />);
